module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/cheq-fce86ef07cd35268b0a14dbc0f15dfb0.png";